import { createFileRoute } from '@tanstack/react-router'
import { LoginPage } from '../components/auth-pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/login')({
  head: () => noIndexRouteHead('login', 'it'),
  component: LoginPage,
})
